import { render, staticRenderFns } from "./feastpage.vue?vue&type=template&id=49c794b7&scoped=true&"
import script from "./feastpage.vue?vue&type=script&lang=js&"
export * from "./feastpage.vue?vue&type=script&lang=js&"
import style0 from "./feastpage.vue?vue&type=style&index=0&id=49c794b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c794b7",
  null
  
)

export default component.exports